import { ReactComponent as SupportTicket } from "@/assets/images/svg/support-ticket.svg";
import { useLang } from "@/hooks/useLang";
import { FilePdfTwoTone, PhoneTwoTone } from '@ant-design/icons';
import { Col, Row } from "antd";
import React, { FC, useContext } from 'react';
import { SettingContext } from "@/context/data/SettingContext";
import { SECURITY_UI_URL } from "@/constants/config.constant";
import PhoneNumberDisplay from "@/components/PhoneNumberDisplay";

const HelpView: FC<any> = props => {
    const { t } = useLang();
    const settingContext = useContext(SettingContext);
    return (
        <>
            <div className="text-center">
                <h5 style={{ fontSize: "1.25rem", fontWeight: 700, marginBottom: "1rem" }}>
                    {t("Issues/Queries About Digital Service Portal")}
                </h5>
                <div className="d-flex mb-3 gap-3 flex-column flex-sm-row justify-content-evenly">
                    <div className="bg-light px-2 py-4 rounded w-100 border" style={{ borderColor: '#92cbdf' }}>
                        <PhoneTwoTone className="mb-2" style={{ fontSize: '50px' }} /><br />
                        {t('Technical Support')}<br />
                        <span style={{ fontWeight: 700, fontSize: "1.5rem", marginBottom: "0px" }}>
                            <PhoneNumberDisplay numbersString={settingContext.fields.support_phone} />
                        </span>
                        <div className="text-danger">
                            {t('Sunday-Thursday 09:00 AM - 05:00 PM')}<br/>
                            ({t('Within Office Hours, except Government Holiday')})
                        </div>
                    </div>
                    <div className="bg-light px-2 py-4 rounded w-100 border" style={{ borderColor: '#92cbdf' }}>
                        <a href={`${SECURITY_UI_URL}/user-manuals`} className="text-primary d-inline-block" target={"_blank"} rel="noopener noreferrer">
                            <FilePdfTwoTone className="mb-2" style={{ fontSize: '80px' }} /><br />
                            {t("User Manuals")}
                        </a>
                    </div>
                </div>
            </div>
            <div className="bg-light p-3 rounded border" role="alert" style={{ borderColor: '#92cbdf' }}>
                <Row>
                    <Col xs={24} sm={16} className="mb-3 mb-sm-0">
                        <h5 className="fw-bold my-0 h6 visually-hidden">{t('Support Ticket')}</h5>
                        {t('Getting support via the Ticketing System is always a recommended way. By this way you can keep track of your issues.')}
                    </Col>
                    <Col xs={24} sm={8} className="text-center text-sm-end">
                        <a href="https://support.most.gov.bd/" className="btn btn-lg text-white" target="_blank" rel="noopener noreferrer" style={{ backgroundColor: '#2596be', borderColor: '#51abcb' }}>
                            <SupportTicket aria-hidden="true" className="me-2 d-none d-sm-inline-block" style={{ width: '14px', fill: '#333', verticalAlign: 'middle' }} />
                            {t("Open a New Ticket")}
                        </a>
                    </Col>
                </Row>
            </div>
        </>
    );
}

export default React.memo(HelpView);
